import { useState } from 'react';
import _ from 'lodash';
import { useAuthenticationMlsStore } from './AuthenticationMls';
import { makeRequest, fetchBaseUrl, processResponse } from './AjaxMls';
import { buildFormData } from '../../lib/UtilityHelper';

export function useProviderHelpersMls() {
    const [data, setData] = useState();

    const { fetchAuthDataMls, login } = useAuthenticationMlsStore();

    // These fields are passed in by validation controls.  They should be ignored and not passed to server
    const ignoredFields = ['ignore_whitespace', 'protocols', 'require_tld', 'require_protocol', 'require_host', 'require_valid_protocol', 'allow_underscores',
        'allow_trailing_dot', 'allow_protocol_relative_urls', 'allow_display_name', 'require_display_name', 'allow_utf8_local_part'];

    const clearData = () => {
        setData(null);
    };

    const setResult = (props) => {
        setData({ status: 'success', scope: props.scope, statusCode: 200, body: props.body });
    };

    const loginMls = async (force = false) => {
        const authData = fetchAuthDataMls();
        if (!force && !_.isEmpty(authData) && !_.isEmpty(authData.accessToken)) {
            return true;
        } else {
            try {
                await login();
            } catch {
                setData({ status: 'error', scope: 'error', statusCode: 500, body: { message: 'Oops! Something went wrong!' } });
            }        
        }
    }

    const execute = async (props, retry = false) => {
        const base_url = fetchBaseUrl();
        let result = null;
        
        setData({ status: 'processing', scope: props.scope, result: null });

        let headers = props.headers; //(props.secure) ? { ...props.headers, ...fetchAuthorizationHeaders() } : props.headers;
        let payload = props.payload;

        if (!_.isEmpty(payload)) {
            Object.keys(payload).forEach((key) => {
                if (_.includes(ignoredFields, key)) {
                    delete payload[key];
                }
            });
        }

        if (props.multipart) {
            let formData = new FormData();
            if (payload) {
                buildFormData(formData, payload);      
            }

            payload = formData;
        }

        try {
            if (!_.isEmpty(props.url)) {
                var response = await makeRequest({ url: `${base_url}/${props.url}`, method: props.method, payload: payload, headers: headers, multipart: props.multipart });
                if(props.secure && response.status === 401 && retry === false){
                    await loginMls(true);
                    execute(props, true);
                } else {
                    result = processResponse(response);
                    if (!_.isEmpty(result) && result.status === 200) {
                        setData({ status: 'success', scope: props.scope, statusCode: result.status, body: result.body });                    
                    } else {
                        setData({ status: 'fail', scope: props.scope, statusCode: result.status, body: result.message });            
                    }
                }
            } else {
                setData({ status: 'success', scope: props.scope, statusCode: 200, body: null });
            }
        } catch {
            setData({ status: 'error', scope: props.scope, statusCode: 500, body: { message: 'Oops! Something went wrong!' } });
        }
    };

    return { data, clearData, execute, loginMls, setResult };
}